import { Button } from '@talentmesh/ui/components/button';
import { Spinner } from '@talentmesh/ui/components/spinner';
import { DialogEnum, useActionDialogContext } from '../../Context/ActionDialogContext';
import UIStrings from '@/Utils/UIStrings';

function HireActions() {
    const { hideDialog, showHireNotification, hireApplicantAsync, isHireLoading } = useActionDialogContext();

    const closeHireDialog = () => {
        hideDialog(DialogEnum.Hire);
    };

    return (
        <Button
            className="w-full"
            size="lg"
            variant="default"
            disabled={isHireLoading}
            onClick={async () => {
                await hireApplicantAsync();
                closeHireDialog();
                showHireNotification();
            }}
        >
            {isHireLoading && <Spinner data-icon="inline-start" />}
            {UIStrings.MarkAsHired}
        </Button>
    );
}

export default HireActions;
